import React, { useContext, useEffect, useState } from "react";
import "../../../../assets/css/user/login/Login.css";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const Login = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { baseUrl, setIsLogin, setUser , regTpChecker} = useContext(AppContext);

  // =========================
  // LOGIN STATES
  // =========================
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);

  // =========================
  // FORGOT PASSWORD STATES
  // =========================
  const [forgotPassword, setForgotPassword] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [checkingEmail, setCheckingEmail] = useState(false);
  const [resettingPassword, setResettingPassword] = useState(false);

  // =========================================================
  // LOGIN CUSTOMER
  // =========================================================
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMessage("Please enter email and password.");
      return;
    }

    setIsLoginLoading(true);
    setErrorMessage("");

    const formdata = new FormData();

    formdata.append("email", email);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/customer/auth/login`, formdata)
      .then((response) => {
        console.log("Full Response:", response.data);
        console.log("Customer:", response.data.customer);

        if (response.data.error) {
          setErrorMessage(response.data.error);
          setIsLoginLoading(false);
          return;
        }

        // Login successful
        setIsLogin(true);

        localStorage.setItem("customerToken", response.data.token);

        localStorage.setItem(
          "loggedInUser",
          JSON.stringify(response.data.customer),
        );

        setUser(response.data.customer);

        navigate("/");
      })
      .catch((error) => {
        console.log(error);

        setErrorMessage(
          error.response?.data?.message || "Invalid email or password.",
        );

        setIsLoginLoading(false);
      });
  };

  // =========================================================
  // CHECK CUSTOMER EMAIL
  // =========================================================
  const checkCustomerEmail = (e) => {
    e.preventDefault();

    setErrorMessage("");

    if (!email) {
      setErrorMessage("Please enter your email.");
      return;
    }

    setCheckingEmail(true);

    axios
      .post(`${baseUrl}/customer/auth/checkCustomerEmail`, {
        email: email,
      })
      .then((response) => {
        console.log("Check Email Response:", response.data);

        if (response.data.success) {
          setEmailVerified(true);
        } else {
          setEmailVerified(false);

          setErrorMessage(response.data.message || "Email not found.");
        }
      })
      .catch((error) => {
        console.log(error);

        setEmailVerified(false);

        setErrorMessage(
          error.response?.data?.message || "This email is not registered.",
        );
      })
      .finally(() => {
        setCheckingEmail(false);
      });
  };

  // =========================================================
  // RESET CUSTOMER PASSWORD
  // =========================================================
  const resetCustomerPassword = (e) => {
    e.preventDefault();

    setErrorMessage("");

    if (!newPassword || !confirmPassword) {
      setErrorMessage("Please enter both new password and confirm password.");
      return;
    }
    const passwordError = regTpChecker("password", newPassword);

if (passwordError) {
  setErrorMessage(passwordError);
  return;
}

if (newPassword !== confirmPassword) {
  setErrorMessage("New password and confirm password do not match.");
  return;
}

    if (newPassword !== confirmPassword) {
      setErrorMessage("New password and confirm password do not match.");
      return;
    }

    setResettingPassword(true);

    axios
      .post(`${baseUrl}/customer/auth/resetCustomerPassword`, {
        email: email,
        new_password: newPassword,
        confirm_password: confirmPassword,
      })
      .then((response) => {
        console.log("Reset Password Response:", response.data);

        if (response.data.success) {
          alert("Password reset successfully.");

          // Back to login
          setForgotPassword(false);
          setEmailVerified(false);

          setNewPassword("");
          setConfirmPassword("");

          setEmail("");
          setPassword("");
          setErrorMessage("");
        } else {
          setErrorMessage(response.data.message || "Password reset failed.");
        }
      })
      .catch((error) => {
        console.log(error);

        setErrorMessage(
          error.response?.data?.message || "Something went wrong.",
        );
      })
      .finally(() => {
        setResettingPassword(false);
      });
  };

  // =========================================================
  // AUTO LOGIN
  // =========================================================
  useEffect(() => {
    const token = localStorage.getItem("customerToken");

    const storedUser = localStorage.getItem("loggedInUser");

    if (token && storedUser) {
      setIsLoading(true);

      try {
        setUser(JSON.parse(storedUser));
        setIsLogin(true);
        navigate("/");
      } catch (error) {
        console.log(error);

        localStorage.removeItem("customerToken");
        localStorage.removeItem("loggedInUser");

        setIsLoading(false);
      }
    }
  }, [navigate, setIsLogin, setUser]);

  // =========================================================
  // UI
  // =========================================================
  return isLoading ? (
    <div
      style={{ height: 50 }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spinner
        style={{
          height: 50,
          width: 50,
          fontSize: 60,
        }}
      />
    </div>
  ) : (
    <>
      <div className="login-page">
        <div className="login-container">
          {/* ================= LEFT SIDE ================= */}
          <div className="login-left">
            <div className="left-content">
              <h1>
                {forgotPassword ? "Reset Your Password" : "Join Us Today!"}
              </h1>

              <p>
                {forgotPassword
                  ? "Enter your email and create a new password"
                  : "Create your account and unlock amazing deals"}
              </p>

              {!forgotPassword && (
                <>
                  <div className="feature-box">🎁 Exclusive Offers</div>

                  <div className="feature-box">⚡ Fast Checkout</div>

                  <div className="feature-box">💰 Huge Discounts</div>

                  <div className="feature-box">🔒 100% Secure</div>
                </>
              )}
            </div>
          </div>

          {/* ================= RIGHT SIDE ================= */}
          <div className="login-right">
            <div className="form-box">
              <h2>{forgotPassword ? "Forgot Password" : "Log In"}</h2>

              <p>
                {forgotPassword
                  ? emailVerified
                    ? "Create your new password"
                    : "Enter your registered email"
                  : "Already have an account?"}
              </p>

              <form
                onSubmit={
                  forgotPassword
                    ? emailVerified
                      ? resetCustomerPassword
                      : checkCustomerEmail
                    : handleSubmit
                }
              >
                {/* ================= EMAIL ================= */}
                <div className="form-group">
                  <label>Email</label>

                  <div className="input-wrapper">
                    <FaEnvelope className="input-icon" />

                    <input
                      type="email"
                      placeholder="Enter your Email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrorMessage("");
                      }}
                      required
                    />
                  </div>
                </div>
                 {/* Error Message */}
              {errorMessage && (
                <div className="buyer-error-message">{errorMessage}</div>
              )}
              {/* Success Message */}
              {successMessage && (
                <div className="buyer-success-message">{successMessage}</div>
              )}

                {/* =================================================
                    NORMAL LOGIN PASSWORD
                   ================================================= */}
                {!forgotPassword && (
                  <div className="form-group">
                    <label htmlFor="password">Password</label>

                    <div className="input-wrapper">
                      <FaLock className="input-icon" />

                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />

                      <button
                        type="button"
                        className="toggle-password"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>
                )}

                {/* =================================================
                    FORGOT PASSWORD LINK
                   ================================================= */}
                {!forgotPassword && (
                  <div className="form-options">
                    <button
                      type="button"
                      className="forgot-password"
                      onClick={() => {
                        setForgotPassword(true);
                        setEmailVerified(false);
                        setErrorMessage("");
                      }}
                    >
                      Forgot Password?
                    </button>
                  </div>
                )}

                {/* =================================================
                    CHECK EMAIL
                   ================================================= */}
                {forgotPassword && !emailVerified && (
                  <button
                    type="button"
                    className="login-btn"
                    onClick={checkCustomerEmail}
                    disabled={checkingEmail}
                  >
                    {checkingEmail ? "Checking..." : "Continue"}
                  </button>
                )}

                {/* =================================================
                    NEW PASSWORD + CONFIRM PASSWORD
                   ================================================= */}
                {forgotPassword && emailVerified && (
                  <>
                    {/* New Password */}
                    <div className="form-group">
                      <label>New Password</label>

                      <div className="input-wrapper">
                        <FaLock className="input-icon" />

                        <input
                          type={showNewPassword ? "text" : "password"}
                          placeholder="Enter new password"
                          value={newPassword}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            setErrorMessage(
                              regTpChecker("password", e.target.value),
                            );
                          }}
                          required
                        />

                        <button
                          type="button"
                          className="toggle-password"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                          {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </div>

                    {/* Confirm Password */}
                    <div className="form-group">
                      <label>Confirm Password</label>

                      <div className="input-wrapper">
                        <FaLock className="input-icon" />

                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Confirm new password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />

                        <button
                          type="button"
                          className="toggle-password"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </div>

                    {/* Reset Password Button */}
                    <button
                      type="submit"
                      className="login-btn"
                      disabled={resettingPassword}
                    >
                      {resettingPassword ? "Resetting..." : "Reset Password"}
                    </button>
                  </>
                )}

                {/* =================================================
                    NORMAL LOGIN BUTTON
                   ================================================= */}
                {!forgotPassword && (
                  <>
                    {errorMessage && (
                      <p className="error-text">{errorMessage}</p>
                    )}

                    {isLoginLoading ? (
                      <div
                        style={{ height: 50 }}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <Spinner size="lg" />
                      </div>
                    ) : (
                      <button type="submit" className="login-btn">
                        Login
                      </button>
                    )}
                  </>
                )}

                {/* =================================================
                    ERROR MESSAGE FOR FORGOT PASSWORD
                   ================================================= */}
                {forgotPassword && errorMessage && (
                  <p className="error-text">{errorMessage}</p>
                )}

                {/* =================================================
                    BACK TO LOGIN
                   ================================================= */}
                {forgotPassword && (
                  <div className="form-footer">
                    <button
                      type="button"
                      className="forgot-password"
                      onClick={() => {
                        setForgotPassword(false);
                        setEmailVerified(false);

                        setNewPassword("");
                        setConfirmPassword("");

                        setEmail("");
                        setErrorMessage("");
                      }}
                    >
                      ← Back to Login
                    </button>
                  </div>
                )}
              </form>

              {/* ================= SIGNUP ================= */}
              {!forgotPassword && (
                <div className="form-footer">
                  <p>
                    Create your account{" "}
                    <Link to="/signup" className="register-link">
                      SignUp
                    </Link>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
